import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appCustomAttribute]'
})
export class CustomAttributeDirective {
  @Input() customHower:string;

  constructor(private el: ElementRef) {
    // el.nativeElement.style.backgroundColor = 'orange';
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.hiliteColor(this.customHower);
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.hiliteColor('yellow');
  }

  public hiliteColor(color) {
    this.el.nativeElement.style.backgroundColor = color;
  }
}



// WEBPACK FOOTER //
// ./public/app/_directives/custom-attribute.directive.ts